import React from 'react';
import Modal from 'react-responsive-modal';
import Message from '../chat/Message';
import { GET_SEPERATOR } from '../../../Utils/Common';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { setActiveMsg, setPopup } from '../../../redux/messageSlice';

const PrivateMessageQuickView = ({ v, privateMsgQuickView, setPrivateMsgQuickView }) => {
    const dispatch = useDispatch();
    const { slug } = useParams()
    const navigate = useNavigate();
    const { user, allUsers } = useSelector(state => state.message);

    const closeIcon = (
        // <MdClose className="text-3xl mt-1 text-teal-600 dark:text-white  dark:text-white" />
        <div className="privateCloseIcon text-3xl mt-1 text-teal-600 dark:text-white  dark:text-white" />
    );

    return (
        <Modal
            open={privateMsgQuickView}
            onClose={() => setPrivateMsgQuickView(false)}
            container={document.getElementById('root')}
            center
            closeIcon={closeIcon}
            focusTrapped={false}
            classNames={{
                overlay: 'customOverlay',
                modal: 'customModal bgSurfaceDarkMainBox',
            }}
        >
            <div className="delete_ChildModalContent">
                <div className="privateEditTitleChat flex justify-between items-center">
                    <p className='!text-[17px] mt-0.5 !text-teal-800 dark:!text-white'>Quick view of private message</p>
                </div>

                <div className="participantsPrivate">
                    <div className="selectedMembersSecPrivate">
                        <div className="selectedMItemPrivate">

                            {allUsers?.filter(f => v.secret_user.includes(f.id) && f.id !== user?.id).map((u, index) => (
                                <div key={index} className="flex items-center gap-2 bg-teal-600 rounded-full pl-2 pr-3 py-1 mr-2 w-full" >
                                    <div className='w-[24px] h-[24px]'>
                                        <img src={u.img} alt={u.firstname} className="w-[24px] h-[24px] rounded-full object-cover" />
                                    </div>

                                    <div>
                                        <p className="!text-white text-sm font-medium whitespace-nowrap">{u.firstname + ' ' + u.lastname}</p>
                                    </div>
                                </div>
                            ))}

                        </div>
                    </div>
                    <div className="submitSectionPrivate">
                        {v.sender === user?.id && <button onClick={() => { dispatch(setActiveMsg(v)); setPrivateMsgQuickView(false); dispatch(setPopup({ key: 'userList', value: { key: 'private_participants', state: true } })) }} className="participantSubmitPrivate dark:text-white">Add/Edit</button>}
                    </div>
                </div>

                {/* Message Quick View */}
                <div className="privateQuickViewSms">
                    {/* <div className='senderMessage mb-3'>
                        <div className='flex items-center mb-2'>
                            <div className='w-10 h-10 rounded-full !bg-[#2C56AC] flex justify-center items-center'>
                                <div className="text-white font-bold">MS</div>
                            </div>
                            <div className="msg_info !mt-0">
                                <div className="sender_info">
                                    <div>
                                        <p className="sender_name !w-auto">MD Ahmed Shakil</p>
                                        <div className='flex'>
                                            <p className="msg_time"><time>4:56 PM</time></p>
                                            <p className="msg_delivered">&nbsp; - Delivered</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="msg_body_text group mb-2">
                            <div
                                className="noSelect msg_txt msg_text_bg !text-sm group-hover:!bg-[#f5f9fc] !bg-[#F3F4F6] p-2 rounded-lg w-fit text-gray-600">Hi, hello there
                            </div>
                        </div>

                    </div> */}
                    <Message
                        data={v}
                        seperator={GET_SEPERATOR([v][0 - 1], v)}
                        is_group_msg={false}
                        quickMsg={true}
                        privateMsgQuickView={privateMsgQuickView}
                    />
                </div>

                <hr />
                <div className="flex justify-end gap-2.5 mt-4">
                    <button onClick={() => setPrivateMsgQuickView(false)} className="px-4 py-2 border border-teal-200 text-teal-600 rounded-md dark:text-white">
                        Cancel
                    </button>
                    <button className="px-4 py-2 bg-teal-600 dark:bg-teal-600 text-white rounded-md" onClick={() => { navigate(`/connect/${slug}/reply/${v?.msg_id}`); setPrivateMsgQuickView(false) }}>
                        Replay
                    </button>
                </div>
            </div>
        </Modal>
    );
};

export default PrivateMessageQuickView;